var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import DrawSpec from './DrawSpec';
import { filter } from './Filter';
import { fit } from './Optimizer';
import { processActorsFirst, processEventsFirst } from './PreProcessing';
import { uuid } from 'uuidv4';
var Storygram = /** @class */function () {
  function Storygram(rawData, config) {
    // Whether the storygram has been filtered, optimized and rendered
    this.isCalculated = false;
    // Default values
    this.baseConfig = {
      uid: uuid(),
      verbose: false,
      colorScheme: 'schemeAccent',
      lineSize: 9,
      eventDescription: function (l) {
        return String(l.eventValue);
      },
      url: function (event, actor) {
        return 'https://www.google.ch/search?q=' + String(event.eventValue) + ' ' + actor.actorID;
      },
      eventUrl: function (event) {
        return 'https://www.google.ch/search?q=' + String(event.eventValue);
      },
      marginTop: 50,
      marginBottom: 50,
      marginLeft: 50,
      urlOpensNewTab: true,
      marginRight: 50,
      eventPadding: 40,
      actorPadding: 30,
      eventValueScaling: 0.9,
      generationAmt: 30,
      populationSize: 50,
      continuous: false,
      compact: false,
      highlight: [],
      strokeWidth: function (event, actor) {
        return 0;
      },
      actorColor: function (event, actor) {
        return actor.actorID;
      },
      mustContain: [],
      shouldContain: [],
      interactedWith: [[], 0],
      filterEventValue: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
      filterGroupSize: [0, Number.MAX_SAFE_INTEGER],
      filterEventCustom: function () {
        return true;
      },
      filterActorCustom: function () {
        return true;
      },
      filterEventValueLifeTime: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
      filterGroupAmt: [0, Number.MAX_SAFE_INTEGER],
      linearLoss: 1,
      amtLoss: 1,
      lengthLoss: 1,
      yExtentLoss: 0,
      root: 'body',
      tooltipPosition: 'absolute',
      hiddenActorsTooltipTitle: 'Hidden actors',
      selectionRate: 0.25,
      selectionSeverity: 8,
      mutationProbability: 0.025,
      inferredEventType: undefined
    };
    this.setConfig(config);
    this.setData(rawData);
    this.calculate();
  }
  Storygram.prototype.setConfig = function (config) {
    this.config = __assign(__assign({}, this.baseConfig), config);
    this.isCalculated = false;
  };
  Storygram.prototype.setData = function (data) {
    var _this = this;
    if (Array.isArray(data)) {
      switch (this.config.dataFormat) {
        case 'ranges':
          this.data = processActorsFirst(data, this.config);
          break;
        case 'table':
          var splitFuncTable = this.config.actorSplitFunction ? this.config.actorSplitFunction : function (arg) {
            return typeof arg === 'string' ? [arg] : arg;
          };
          this.data = processEventsFirst(data, this.config.actorFields, splitFuncTable, this.config, this.config.eventField);
          break;
        case 'array':
          var splitFuncArray = function (arg) {
            return arg.reduce(function (arr, a) {
              return _this.config.actorSplitFunction ? arr.concat(_this.config.actorSplitFunction(a)) : arr.concat(a);
            }, new Array());
          };
          this.data = processEventsFirst(data, [this.config.actorArrayField], splitFuncArray, this.config, this.config.eventField);
          break;
        default:
          console.error('Incompatible data format. Specify a data format of type ranges, table or array.');
      }
    } else {
      console.error('Incompatible data format. Provide data in array shape.');
    }
    this.isCalculated = false;
  };
  // Imports the data and applies filtering
  Storygram.prototype.calculate = function () {
    this.processedData = filter(this.data, this.config);
    this.isCalculated = true;
  };
  // Draw the storygram on the DOM. If the importation and filtering steps aren't yet made, perform these first
  Storygram.prototype.draw = function () {
    if (!this.isCalculated) {
      this.calculate();
    }
    this.processedData = fit(this.processedData, this.config);
    this.renderedGrid = DrawSpec.createGrid(this.processedData, this.config);
    if (this.config.verbose) {
      console.log(this.renderedGrid);
    }
    this.remove();
    if (this.processedData.events.length !== 0 && this.processedData.actors.size !== 0) {
      DrawSpec.drawD3(this.renderedGrid, this.config);
    } else {
      console.warn('Storygram: No data after filtering');
    }
  };
  Storygram.prototype.remove = function () {
    DrawSpec.remove(this.config);
  };
  return Storygram;
}();
export default Storygram;